import { LinkedinSmall as o } from "./linkedin-small.js";
import { FacebookSmall as m } from "./facebook-small.js";
import { TwitterSmall as r } from "./twitter-small.js";
import { AdyenA as t } from "./adyen-a.js";
const p = {
  LinkedinSmall: o,
  FacebookSmall: m,
  TwitterSmall: r,
  AdyenA: t
};
export {
  p as Extra24
};
